import { get } from '@/helper/request';
import useRestClient from '@/hooks/useRestClient';
import useRestQuery from '@/hooks/useRestQuery';

const BLOCK_API_PATH = '/api/block/doc?op=rest-block';

export const getDoc = (blockId: string, contentId: string) =>
  get(BLOCK_API_PATH, { blockId, contentId }).then((res) => {
    if (res?.success) {
      return res?.document;
    }
    throw new Error(res.message);
  });

export const prefetchBlock = (
  queryClient: ReturnType<typeof useRestClient>,
  rootBlockId: string,
  contentId: string,
) => queryClient.prefetchQuery(['blockDoc', rootBlockId], () => getDoc(rootBlockId, contentId));

const useRestBlocks = (rootBlockId?: string | null, contentId?: string | null) => {
  const query = useRestQuery(['blockDoc', rootBlockId], () => getDoc(rootBlockId!, contentId!), {
    enabled: !!rootBlockId,
  });

  return {
    loading: query.isLoading,
    data: query.data,
    error: query.error,
  };
};

export default useRestBlocks;
